import React from 'react';
import PropTypes from 'prop-types';
import messages from '../../lib/messages.js';
import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';

import eraserIcon from './eraser.svg';

const BitEraserComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.eraser}
    imgSrc={eraserIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="E"
  />
);

BitEraserComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default BitEraserComponent;
